import { Dimensions } from "@/state/Furniture";

/**
 * Dimensions are in the format "[height]x[width]x[depth] [unit]"
 *
 * @param dimensions
 * @returns
 */
const DIMENSIONS_REGEX = /(\d+)\s*x\s*(\d+)\s*x\s*(\d+)\s+([\wа-яА-Я]+)/;

export const parseDimensions = (dimensions: string): Dimensions => {
    const match = dimensions.match(DIMENSIONS_REGEX);
    if (!match) {
        throw new Error("Invalid dimensions");
    }

    const result = {
        height: Number(match[1]),
        width: Number(match[2]),
        depth: Number(match[3]),
        unit: match[4],
    };

    return result;
};

export const formatDimensions = (dimensions: Dimensions) => {
    return `${dimensions.width}x${dimensions.height}x${dimensions.depth} ${dimensions.unit}`;
};
